import { ref } from "vue";
import { defineStore } from "pinia";

export interface Node {
  id: number;
  childrenCount: number;
  childrenUrl: string;
  children: any;
  name: string;
  parentId: number;
  url: string;
  nodePath: string;
}

export const useSelectedNodeStore = defineStore("selectedNode", () => {
  const selectedNodePath: ref<string | null> = ref(null);

  function isSelectedNode(nodePath: string): boolean {
    let isSelected = false;
    if (selectedNodePath.value) {
      isSelected = nodePath === selectedNodePath.value;
    }
    return isSelected;
  }
  function isInSelectedPath(id: number): boolean {
    return selectedNodePath?.value.includes(id.toString()) ?? false;
  }
  function setSelectedNodePath(path: string | null): void {
    selectedNodePath.value = path;
  }

  return {
    selectedNodePath,
    isSelectedNode,
    isInSelectedPath,
    setSelectedNodePath,
  };
});
